import { SET_SUBSCRIBER_ORDERS } from './actions';

const INITIAL_STATE = null;

const purchaseReducer = (state = INITIAL_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_ORDERS: {
               return { ...state, orders: action.payload };
          }

          default:
               return state;
     }
};

// Get order subscriber by id
export const getOrderSubscriberById = (state, orderId) => state.subscriber.purchase.orders.find((order) => order.id === orderId);

export default purchaseReducer;
